
import marked from "marked";
import Vue from "vue";
import axios from "axios";
import { hideNonProfessorStaffLists } from "@/config/staffDisplay";

let rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
rendererMD.heading = function (text, level) {
  return `<h${level} style="margin-bottom:20px;margin-top:20px">${text}</h${level}>`;
};
rendererMD.link = function (href, title, text) {
  return `<a style="color:var(--color-primary);text-decoration:none;" href=${href}>${text}</a>`;
};

export default Vue.extend({
  data: () => ({
    text: "",
    name: "",
  }),
  computed: {
    markdown(): string {
      return marked(this.text);
    },
  },
  mounted() {
    axios
      .post(Vue.prototype.apiUrl("get-item-by-engName"), {
        collection: "staff",
        engName: this.$route.params.engName,
      })
      .then((response) => {
        let tmp = (response.data as any)[0];
        this.name = tmp.name;
        this.text = Vue.prototype.replaceLocalhostInContent(tmp.content);
      });
  },
});
